import React, { useState } from 'react'
import PropTypes, { number } from 'prop-types'
import Warning from '../../../svg/Warning'
import Close from '../../../svg/Close'

const WarningCard = ({ error, closeButton, warningSize, closeSize }) => {
    const [isVisible, setIsVisible] = useState(closeButton)

    const handleClose = () => {
        setIsVisible(false)
    }

    return closeButton || error ? (
        <div className="absolute bottom-full right-0 md:w-96 w-full h-auto bg-white">
            <div className="w-full h-full gap-x-3.5 bg-yellowLight border-l-4 p-4 border-yellow flex items-top md:justify-center justify-start">
                <Warning size={warningSize} />
                <p className="text-textDarkerGray font-medium text-sm">
                    {error}
                </p>
                {isVisible && <Close size={closeSize} onClick={handleClose} />}
            </div>
        </div>
    ) : null
}

WarningCard.propTypes = {
    error: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    closeButton: PropTypes.bool,
    warningSize: number,
    closeSize: number,
}

export default WarningCard
